window.ProductVariantSelectors = {
  container: "#product",
  variantOption: ".js--variant-option",
  variantId: ".js--variant-id",
  variantInventoryQuantity: ".js--variant-inventory-quantity",
  variantPrice: ".js--variant-price",
  variantCompareAtPrice: ".js--variant-compare-price",
  variantSku: ".js--variant-sku",
  pantsSize: ".js--pants-size",
  pantsSizeDetail: ".js--pants-size-detail",
  addToCartButton: ".js--add-to-cart",
  notifyMeButton: ".js--notify-me",
  klaviyoForm: ".js--klaviyo-form-slot",
  variantForm: ".js--variant-form",
  findInStore: {
    openButton: "#find-in-store-sidebar-open-button",
    sidebar: "#find-in-store-sidebar",
    closeButton: "#find-in-store-sidebar-close-button",
    optionSelect: ".find-in-store__product-option-select",
    priceActual: ".find-in-store__price-actual",
    priceCompare: ".find-in-store__price-compare",
    addToCartButton: ".find-in-store__add-to-cart-button",
    notifyMeButton: ".find-in-store__notify-me-button",
  },
};

const SEL = window.ProductVariantSelectors;

const VARIANT_PARAM = "variant";

window.ProductVariantSettings = () => settingsFromContainer(document.querySelector(SEL.container));

const readSettings = (containerElement) => {
  return {
    variants: JSON.parse(containerElement.getAttribute("data-variants")),
    variant_inventory_quantities: JSON.parse(
      containerElement.getAttribute("data-variant-inventory-quantities"),
    ),
    variant_force_out_of_stock: JSON.parse(
      containerElement.getAttribute("data-variant-force-out-of-stock") ?? "[]",
    ),
    product_title: containerElement.getAttribute("data-product-title"),
    inventory_reserve: parseInt(containerElement.getAttribute("data-inventory-reserve") ?? "10", 10),
  };
};

const settingsByContainer = new WeakMap();

const settingsFromContainer = (containerElement) => {
  if (!settingsByContainer.has(containerElement)) {
    settingsByContainer.set(containerElement, readSettings(containerElement));
  }
  return settingsByContainer.get(containerElement);
};

window.ProductVariantState = (() => {
  let currentVariant = null;
  const listeners = [];

  const setVariant = (variant) => {
    if (currentVariant?.id === variant?.id) return;
    currentVariant = variant;
    listeners.forEach((listener) => listener(variant));
  };

  const onVariantChange = (listener) => listeners.push(listener);
  const getVariant = () => currentVariant;

  return { setVariant, onVariantChange, getVariant };
})();

const stripTrailingZeros = (formatted) => formatted.replace(/\.00$/, "");

window.formatVariantPrice = (variant) => ({
  actual: stripTrailingZeros(Shopify.formatMoney(variant.price)),
  compare:
    variant.compare_at_price > variant.price
      ? stripTrailingZeros(Shopify.formatMoney(variant.compare_at_price, "${{amount}}"))
      : "",
});

window.setIfDifferent = (element, property, value) => {
  if (element[property] !== value) element[property] = value;
};

window.setTextIfDifferent = (node, text) => {
  if (node.childElementCount > 0 || node.textContent !== text) node.textContent = text;
};

window.setAttributeIfDifferent = (element, name, value) => {
  if (element.getAttribute(name) !== value) element.setAttribute(name, value);
};

window.showComparePrice = (el, compare) => {
  window.setTextIfDifferent(el.lastChild, compare);
  window.setIfDifferent(el, "hidden", !compare);
};

window.getVariantPurchaseState = (
  variant,
  variantsList,
  variantInventoryQuantities,
  variantForceOutOfStock,
  productTitle,
  inventoryReserve = 10,
) => {
  const variantIndex = variantsList.findIndex((v) => v.id === variant.id);
  const inventoryQuantity = variantInventoryQuantities[variantIndex];
  const isUnavailable =
    variantForceOutOfStock[variantIndex] === true ||
    variant.available === false ||
    (inventoryQuantity <= inventoryReserve && !product_is_gift_card);
  const buttonText =
    inventoryQuantity > inventoryReserve &&
    inventoryQuantity <= inventoryReserve + 5 &&
    !productTitle.includes("Gift Card")
      ? "Low In Stock - Add To Cart"
      : "Add To Cart";
  return { inventoryQuantity, isUnavailable, buttonText };
};

const updateVariantIdFields = (containerElement, variant) => {
  window.setIfDifferent(containerElement.querySelector(SEL.variantId), "value", String(variant.id));
};

const updateVariantPriceFields = (containerElement, variant) => {
  const price = window.formatVariantPrice(variant);
  containerElement
    .querySelectorAll(SEL.variantPrice)
    .forEach((el) => window.setIfDifferent(el, "innerHTML", price.actual));
  containerElement.querySelectorAll(SEL.variantCompareAtPrice).forEach((el) => window.showComparePrice(el, price.compare));
};

const updateVariantSkuFields = (containerElement, variant) => {
  containerElement.querySelectorAll(SEL.variantSku).forEach((el) => window.setTextIfDifferent(el, variant.sku ?? ""));
};

const updatePantsSizeField = (containerElement, variant) => {
  const pantsSize = containerElement.querySelector(SEL.pantsSize);
  if (!pantsSize) return;
  window.setTextIfDifferent(pantsSize, String(variant.option1 - 12));
  const detail = containerElement.querySelector(SEL.pantsSizeDetail);
  if (detail) detail.hidden = false;
};

const updateAddToCartAndNotifyMe = (containerElement, settings, variant) => {
  const { inventoryQuantity, isUnavailable, buttonText } = window.getVariantPurchaseState(
    variant,
    settings.variants,
    settings.variant_inventory_quantities,
    settings.variant_force_out_of_stock,
    settings.product_title,
    settings.inventory_reserve,
  );

  const addToCartButton = containerElement.querySelector(SEL.addToCartButton);
  if (addToCartButton) {
    window.setIfDifferent(addToCartButton, "disabled", isUnavailable);
    addToCartButton.style.display = isUnavailable ? "none" : "flex";
    if (!isUnavailable) window.setTextIfDifferent(addToCartButton, buttonText);
  }

  const notifyMeButton = containerElement.querySelector(SEL.notifyMeButton);
  if (notifyMeButton) {
    notifyMeButton.style.display = isUnavailable ? "flex" : "none";
    if (isUnavailable) window.setTextIfDifferent(notifyMeButton, "Size Out of Stock - Notify Me");
  }

  const klaviyoForm = containerElement.querySelector(SEL.klaviyoForm);
  if (klaviyoForm) klaviyoForm.style.display = "none";

  const inventoryField = containerElement.querySelector(SEL.variantInventoryQuantity);
  if (inventoryField) window.setIfDifferent(inventoryField, "value", String(inventoryQuantity));
};

const enableFindInStoreButton = (containerElement) => {
  const button = containerElement.querySelector(SEL.findInStore.openButton);
  if (button) button.disabled = false;
};

const replaceAddressPastHistoryHooks = (url) =>
  History.prototype.replaceState.call(window.history, window.history.state, document.title, url);

const syncVariantUrl = (variant) => {
  const url = new URL(window.location.href);
  const variantId = variant ? String(variant.id) : null;
  if (url.searchParams.get(VARIANT_PARAM) === variantId) return;
  const pairs = url.search
    .slice(1)
    .split("&")
    .filter((pair) => pair !== "" && pair.split("=")[0] !== VARIANT_PARAM);
  if (variantId) pairs.push(`${VARIANT_PARAM}=${variantId}`);
  url.search = pairs.join("&");
  replaceAddressPastHistoryHooks(url);
};

const renderVariantPurchaseDetails = (containerElement, settings, variant) => {
  updateVariantIdFields(containerElement, variant);
  updateVariantPriceFields(containerElement, variant);
  updateVariantSkuFields(containerElement, variant);
  updatePantsSizeField(containerElement, variant);
  updateAddToCartAndNotifyMe(containerElement, settings, variant);
  enableFindInStoreButton(containerElement);
};

window.ProductVariantState.onVariantChange((variant) => {
  const containerElement = document.querySelector(SEL.container);
  if (!containerElement) return;
  syncVariantUrl(variant);
  if (!variant) return;

  const variantOptions = containerElement.querySelectorAll(SEL.variantOption);
  const settings = settingsFromContainer(containerElement);
  if (!radiosShowVariant(variantOptions, variant)) {
    variantOptions.forEach((radio) => {
      radio.checked = radio.value === variant[radio.name];
    });
    updateOptionAvailability(containerElement, settings, variantOptions);
  }
  renderVariantPurchaseDetails(containerElement, settings, variant);
});

const OPTION_NAMES = ["option1", "option2", "option3"];

const checkedOptionValues = (variantOptions) => {
  const checked = { option1: null, option2: null, option3: null };
  variantOptions.forEach((opt) => {
    if (opt.checked) checked[opt.name] = opt.value;
  });
  return checked;
};

const radiosShowVariant = (variantOptions, variant) => {
  const checked = checkedOptionValues(variantOptions);
  return OPTION_NAMES.every((name) => checked[name] === variant[name]);
};

window.variantMatchesSelection = (variant, selection) =>
  OPTION_NAMES.every((name) => selection[name] == null || variant[name] === selection[name]);

window.optionCombinationExists = (variants, selection, name, value) => {
  const candidate = { ...selection, [name]: value };
  return variants.some((variant) => window.variantMatchesSelection(variant, candidate));
};

const OPTION_BOX = ".variant-option";
const UNMATCHED_OPTION = "variant-option--unmatched";
const SOLD_OUT_OPTION = "js--sold-out-option";
const STRUCK_OPTION = "variant-option--sold-out";
const SOLD_OUT_NOTE = ".js--sold-out-note";
const STRUCK_STYLE = "struck";

const buyableVariants = (settings) =>
  settings.variants.filter(
    (variant) =>
      !window.getVariantPurchaseState(
        variant,
        settings.variants,
        settings.variant_inventory_quantities,
        settings.variant_force_out_of_stock,
        settings.product_title,
        settings.inventory_reserve,
      ).isUnavailable,
  );

const clearClashingChoices = (variants, variantOptions, chosen) => {
  const selection = checkedOptionValues(variantOptions);
  if (window.optionCombinationExists(variants, selection, chosen.name, chosen.value)) return;
  variantOptions.forEach((option) => {
    if (option.name !== chosen.name) option.checked = false;
  });
};

const markSoldOut = (box, soldOut, struck) => {
  box.classList.toggle(SOLD_OUT_OPTION, soldOut);
  box.classList.toggle(STRUCK_OPTION, soldOut && struck);
  const note = box.querySelector(SOLD_OUT_NOTE);
  if (note) window.setIfDifferent(note, "hidden", !soldOut);
};

const updateOptionAvailability = (containerElement, settings, variantOptions) => {
  const selection = checkedOptionValues(variantOptions);
  const soldOutStyle = containerElement.dataset.soldOutStyle;
  const buyable = soldOutStyle ? buyableVariants(settings) : [];
  variantOptions.forEach((option) => {
    const matched = window.optionCombinationExists(settings.variants, selection, option.name, option.value);
    window.setIfDifferent(option, "disabled", !matched);
    if (!matched) option.checked = false;
    const box = option.closest(OPTION_BOX);
    if (!box) return;
    box.classList.toggle(UNMATCHED_OPTION, !matched);
    if (!soldOutStyle) return;
    const soldOut = !matched || !window.optionCombinationExists(buyable, selection, option.name, option.value);
    markSoldOut(box, soldOut, soldOutStyle === STRUCK_STYLE);
  });
};

const chooseUnmatchedOption = (event) => {
  const option = event.target.closest("label")?.control;
  if (!option?.disabled || !option.matches(SEL.variantOption)) return;
  event.preventDefault();
  option.disabled = false;
  option.checked = true;
  option.dispatchEvent(new Event("change", { bubbles: true }));
};

const missingChoicePrompt = (containerElement) => {
  const groups = containerElement.querySelectorAll("[data-select-prompt]");
  for (let i = 0; i < groups.length; i++) {
    if (!groups[i].querySelector(`${SEL.variantOption}:checked`)) return groups[i].dataset.selectPrompt;
  }
  return "Select Size";
};

const resetAddToCartPrompt = (containerElement) => {
  const addToCartButton = containerElement.querySelector(SEL.addToCartButton);
  if (addToCartButton) {
    window.setIfDifferent(addToCartButton, "disabled", true);
    addToCartButton.style.display = "flex";
    window.setTextIfDifferent(addToCartButton, missingChoicePrompt(containerElement));
  }
  const notifyMeButton = containerElement.querySelector(SEL.notifyMeButton);
  if (notifyMeButton) notifyMeButton.style.display = "none";
  const klaviyoForm = containerElement.querySelector(SEL.klaviyoForm);
  if (klaviyoForm) klaviyoForm.style.display = "none";
  const pantsSizeDetail = containerElement.querySelector(SEL.pantsSizeDetail);
  if (pantsSizeDetail) window.setIfDifferent(pantsSizeDetail, "hidden", true);
};

const variantFromUrl = (variants) => {
  const linkedId = Number(new URLSearchParams(location.search).get(VARIANT_PARAM));
  return variants.find((variant) => variant.id === linkedId);
};

window.updateProductPurchaseDetails = (containerElement) => {
  const settings = settingsFromContainer(containerElement);
  const isMainProduct = containerElement.id === "product";
  const variantOptions = containerElement.querySelectorAll(SEL.variantOption);

  const resolveCheckedVariant = () => {
    const checkedOptions = checkedOptionValues(variantOptions);
    return settings.variants.find((variant) =>
      OPTION_NAMES.every((name) => variant[name] === checkedOptions[name]),
    );
  };

  updateOptionAvailability(containerElement, settings, variantOptions);

  variantOptions.forEach((option) => {
    option.addEventListener("change", () => {
      clearClashingChoices(settings.variants, variantOptions, option);
      updateOptionAvailability(containerElement, settings, variantOptions);
      const variant = resolveCheckedVariant();
      if (!variant) {
        resetAddToCartPrompt(containerElement);
        if (isMainProduct) window.ProductVariantState.setVariant(null);
        return;
      }

      if (isMainProduct) {
        window.ProductVariantState.setVariant(variant);
      } else {
        renderVariantPurchaseDetails(containerElement, settings, variant);
      }
    });
  });
  containerElement.addEventListener("click", chooseUnmatchedOption);

  const linkedVariant = isMainProduct && variantOptions.length > 0 && variantFromUrl(settings.variants);
  if (linkedVariant) window.ProductVariantState.setVariant(linkedVariant);

  const notifyMeButtons = containerElement.querySelectorAll(SEL.notifyMeButton);
  const klaviyoForm = containerElement.querySelector(SEL.klaviyoForm);
  if (!klaviyoForm) return;

  notifyMeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (klaviyoForm.style.display === "none" || klaviyoForm.style.display === "") {
        klaviyoForm.style.display = "block";
        button.style.display = "none";
      }
    });
  });
};

ready(() => {
  const productContainer = document.querySelector(SEL.container);
  if (productContainer) window.updateProductPurchaseDetails(productContainer);
});
